import { useMutation } from "react-query";
import { validateMassAgreementData } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useValidateData = () => {
  return useMutation(validateMassAgreementData);
};

export default useValidateData;
